import Vue from 'vue';
import App from './App.vue';
import router from './routes';
import store from '@/store';
// 过滤器
import filters from "@/filters";
// svgIcon组件注册
import "@/icons";
import "@/assets/styles/index.less";
import "@/plugins";

Object.keys(filters).forEach(item => Vue.filter(item, filters[item]));

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
